import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import './ForceLogoutDialog.css';

/**
 * Shown when loginActive = false and user is signed in.
 * User must confirm before being signed out.
 */
export default function ForceLogoutDialog({ message, onConfirm }) {
    return (
        <Dialog open={true} disableEscapeKeyDown>
            <DialogContent id="force-logout-content">
                <p id="force-logout-message">{message || 'We are currently under maintenance. You will be logged out.'}</p>
            </DialogContent>
            <DialogActions id="force-logout-actions">
                <Button variant="contained" onClick={onConfirm} id="force-logout-btn">
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
}
